import React, {Fragment} from 'react'
import { graphql, StaticQuery } from 'gatsby'


class Hero extends React.Component{
    constructor(props){
        super(props)
    }

    render(){
    const {headerBackBlue} = this.props.query;
        return(
            <Fragment>
                <div className="sporing-banner">
                   <h3 className="for-desktop">Det är smart att röra på sig!</h3>
                   <h3 className="for-mobile">Det är smart att röra <br/>på sig!</h3>
                   <h5>Foto: Glenn T Unger</h5>
                </div>
                <div className="sporing">
                    <div className="custom-container">
                        <div className="inner-sporing for-desktop">
                       
                        <h6>I vår strävan efter att hjälpa barn med plugget insåg vi att många studier  <br/>  pekar på tydliga positiva samband mellan fysisk aktivitet och inlärning. </h6>
                        
                        <p>Kort sagt, att röra på sig kan förbättra människors inlärnings- och koncentrationsförmåga. <br/> Samtidigt visar rapporter att barn från hela vårt avlånga land är alltför stillasittande. Det behöver vi <br/> göra någonting åt. Vi bestämde oss för att försöka hjälpa barn och föräldrar att bejaka en aktiv livsstil.</p>
                        <p><em>Hur? Genom att sänka trösklarna till några av de absolut roligaste <br/> idrottsevenemangen för barn och unga.</em></p>
                        <p>År 2019 startade vi ett samarbete med Göteborgsvarvets barn- och ungdomslopp där det helt enkelt skulle <br/> vara gratis att delta. Albert skulle stå för notan. Det dröjde inte länge förrän initiativet spred sig vidare. <br/> Idag är vi stolta och glada över att kunna erbjuda alla barn en gratis startplats i de största barnloppen <br/> som finns i Sverige. Det hade aldrig gått utan våra vänner och eldsjälar på Göteborgsvarvet, Stockholm <br/> Marathon, Lidingöloppet, Tjejmilen, Tjurruset och Urban Trail. Tack för inspirationen.</p>
                        
                        </div>
                        <div class="inner-sporing for-mobile">
                          
                            
                            <h6>I vår strävan efter att hjälpa barn med plugget insåg <br/> vi att många studier pekar på tydliga positiva <br/> samband mellan fysisk aktivitet och inlärning. </h6>
                            
                            <p>Kort sagt, att röra på sig kan kan förbättra <br/>   människors inlärningsförmåga och <br/>   koncentrationsförmåga.  Samtidigt visar rapporter att <br/>   barn från hela vårt avlånga land är allt för <br/>  stillasittande. Det behöver vi   göra någonting åt. Vi  <br/> bestämde oss för att försöka hjälpa barn och <br/>  föräldrar att bejaka en aktiv livsstil. </p>

                            <p><em>Hur? Genom att sänka trösklarna för att kunna delta  <br/> i några av de absolut roligaste  idrottsevenemangen  <br/> för barn och unga.</em></p>
                            <p> 2019 startade vi ett samarbete med   <br/> Göteborgsvarvets barn och ungdomslopp där det   <br/> helt enkelt skulle  vara gratis att delta. Albert skulle   <br/> stå för notan. Det dröjde inte länge förrän initiativet   <br/> spred sig vidare.  Idag är vi stolta och glada över att  <br/> kunna erbjuda alla barn en gratis startplats i de  <br/>största barnloppen    som finns i Sverige. Det hade <br/> aldrig gått utan våra vänner och eldsjälar på <br/>Göteborgsvarvet, Stockholm    Marathon, Lidingöloppet, <br/>Tjejmilen, Tjurruset och Urban Trail. Tack för <br/>inspirationen.</p>
                        
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

export default (props) => (
    <StaticQuery
        query= { graphql`
                query {
                    headerBackBlue: file(relativePath: {regex: "/plain-background/"}) {
                        publicURL
                    }
                }`
            }
        render={(data)  => (
           <Hero query={data} {...props}/>
        )}
    />
)